import React from 'react'

export default function Header() {
    return (
        <div className='w-full h-[60px] bg-[#9E2064] flex justify-start items-center'>
            <div className='text-white	 text-xl mx-6	    '>
                <img src="assets/images/Maison QR white full logo.svg" alt="" className='' />
                <p className='text-[14px] text-center'>Admin</p>
            </div>

        </div>
    )
}
